export default function Skeleton({ className = "", testId }) {
  return (
    <div
      className={`relative overflow-hidden bg-atelier-surface/40 ${className}`}
      data-testid={testId}
      aria-hidden="true"
    >
      <div className="absolute inset-0 skeleton-shimmer" />
      <style>{`
        .skeleton-shimmer {
          background: linear-gradient(90deg, transparent 0%, rgba(182,198,241,0.08) 50%, transparent 100%);
          animation: skeleton-sweep 1.6s ease-in-out infinite;
        }
        @keyframes skeleton-sweep {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}

export function SkeletonProjectCard() {
  return (
    <div className="atelier-border p-6 flex flex-col gap-5">
      <div className="flex justify-between items-start border-b atelier-border-soft pb-4">
        <div className="flex-1">
          <Skeleton className="h-3 w-24 mb-3" />
          <Skeleton className="h-7 w-3/4" />
        </div>
        <Skeleton className="h-8 w-16" />
      </div>
      <Skeleton className="aspect-video w-full" />
      <div className="grid grid-cols-3 gap-4 border-b atelier-border-soft pb-5">
        <div><Skeleton className="h-2 w-16 mb-2" /><Skeleton className="h-4 w-12" /></div>
        <div><Skeleton className="h-2 w-12 mb-2" /><Skeleton className="h-4 w-10" /></div>
        <div><Skeleton className="h-2 w-20 mb-2" /><Skeleton className="h-4 w-14" /></div>
      </div>
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-5/6" />
    </div>
  );
}
